import { useWishlist } from "../../contexts/WishlistContext";
import "./WishNotice.css";

/**
 * One quiet line when a wish could not be saved, or when a guest wishes for
 * the first time.
 *
 * Deliberately not a dialog and not dismissible-by-default: the heart has
 * already told the shopper what happened by moving back, and this only says
 * why. `role="status"` with `aria-live="polite"` so a screen reader hears it
 * after whatever it was already saying, rather than interrupting.
 */
const WishNotice = () => {
  const { notice, dismissNotice } = useWishlist() ?? {};
  if (!notice) return null;

  return (
    <div className={`wish-notice wish-notice--${notice.tone}`} role="status" aria-live="polite">
      <span>{notice.text}</span>
      <button type="button" className="wish-notice__close" onClick={dismissNotice} aria-label="Dismiss">
        ×
      </button>
    </div>
  );
};

export default WishNotice;
